import PanelBase from '../../base/PanelBase';
import { ITabProperties } from './entities/ITabProperties';
import { IPropertyField, MultiLanguageText } from '../../../../entities/common';
import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';

export default class Tab extends PanelBase {
	selected: boolean;
	icon: string;
	orderNo: number;
	key: string;
	__title: MultiLanguageText;

	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.Tab;

		this.caption.visible = false;

		this.headerMode = 'none';
		this.style = { minHeight: 150 };
	}

	__getMLClassPath() {
		return [...super.__getMLClassPath(), '__title'];
	}

	initialize() {
		super.initialize();
		this.title.removeAll();
	}

	__loadProperties(data: ITabProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.selected = data.selected;
		this.__proxyChanged.icon = data.icon;
		this.__proxyChanged.orderNo = data.orderNo;
		this.__proxyChanged.key = data.key;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			selected: this.selected,
			icon: this.icon,
			orderNo: this.orderNo,
			key: this.key,
			title: this.__title.getData()
		};
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'selected',
				type: 'boolean',
				common: true
			},
			{
				name: 'icon',
				type: 'string'
			},
			{
				name: 'orderNo',
				type: 'number'
			},
			{
				name: 'key',
				type: 'string',
				readOnly: true
			}
		];
	}

	__render(children?: JSX.Element) {
		return super.__render();
	}
}
